import { Observable } from "rxjs";

import { ProductScheduleSlotsRepository } from "lib/repositories/index";
import { ProductScheduleSlotFullDecorator } from "lib/decorators/index";
import st from "lib/utils/index";
import { pushRoute, createAlert, removeAlert } from "modules/app/actions";
import { createResourceInstance, createFormInstance } from "modules/utils/index";

export const OPEN = "calendar/ShowSlotModal/OPEN";
export const CLOSE = "calendar/ShowSlotModal/CLOSE";
export const LOAD_SLOT = "calendar/ShowSlotModal/LOAD_SLOT";
export const FETCH_SLOT = "calendar/ShowSlotModal/FETCH_SLOT";
export const FETCH_SLOT_START = "calendar/ShowSlotModal/FETCH_SLOT_START";
export const FETCH_SLOT_SUCCESS = "calendar/ShowSlotModal/FETCH_SLOT_SUCCESS";
export const FETCH_SLOT_FAILURE = "calendar/ShowSlotModal/FETCH_SLOT_FAILURE";
export const INITIALIZE_MODEL = "calendar/ShowSlotModal/INITIALIZE_MODEL";
export const UPDATE_MODEL = "calendar/ShowSlotModal/UPDATE_MODEL";
export const VALIDATE = "calendar/ShowSlotModal/VALIDATE";
export const SUBMIT = "calendar/ShowSlotModal/SUBMIT";
export const FETCH_SUBMIT_START = "calendar/ShowSlotModal/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "calendar/ShowSlotModal/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "calendar/ShowSlotModal/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.calendar.ShowSlotModal;

const slotResource = createResourceInstance({
  LOAD: LOAD_SLOT,
  FETCH: FETCH_SLOT,
  FETCH_START: FETCH_SLOT_START,
  FETCH_SUCCESS: FETCH_SLOT_SUCCESS,
  FETCH_FAILURE: FETCH_SLOT_FAILURE,
  stateSelector,
  stateKey: "slot",
  getModel: ({ slotId }) => {
    return ProductScheduleSlotsRepository.find(slotId);
  },
});
const editedSlotRepository = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  stateKey: "editedSlot",
  submitModel: ({ editedSlot: { model: slot } }) => {
    return ProductScheduleSlotsRepository.update(slot, {
      withAllFutureSlots: false,
      // This view edits the two concrete datetimes only (TRI-817, point 3).
      // The slot still carries its schedule's offset for display, and sending
      // it back would re-stamp the datetime the operator just changed or
      // cleared.
      withSaleWindowRule: false,
    });
  },
});

const initialState = {
  slot: slotResource.initialState,
  editedSlot: editedSlotRepository.initialState,
  opened: false,
  slotId: null,
};

const reducers = {
  ...slotResource.reducersMap,
  ...editedSlotRepository.reducersMap,

  [OPEN]: (state, { slotId }) => ({
    ...initialState,
    opened: true,
    slotId,
  }),

  [CLOSE]: (state) => ({
    ...state,
    opened: false,
  }),
};

const epics = [
  ...slotResource.epics,
  ...editedSlotRepository.epics,

  (actions$) => actions$.ofType(OPEN).mapTo(fetchSlot()),

  (actions$) =>
    actions$
      .ofType(LOAD_SLOT)
      .merge(actions$.ofType(FETCH_SLOT_SUCCESS))
      .map(({ model: slot }) => initializeModel(slot)),
];

export const { fetch: fetchSlot, load: loadSlot } = slotResource.actions;
export const { initializeModel, updateModel: updateSlot, validate, submit } = editedSlotRepository.actions;

export function open(slot) {
  return (dispatch, getState) => {
    const { opened, slotId } = stateSelector(getState());
    if (!(opened && slotId === slot.id)) {
      dispatch({ type: OPEN, slotId: slot.id });
    }

    const location = getState().app.location;
    if (location.query.showSlot !== slot.id) {
      dispatch(
        pushRoute({
          ...location,
          query: {
            ...location.query,
            showSlot: slot.id,
          },
        })
      );
    }
  };
}

export function close() {
  return (dispatch, getState) => {
    const { opened } = stateSelector(getState());
    if (opened) {
      dispatch({ type: CLOSE });
    }

    const location = getState().app.location;
    if (location.query.showSlot) {
      dispatch(
        pushRoute({
          ...location,
          query: {
            ...location.query,
            showSlot: undefined,
            action: undefined,
          },
        })
      );
    }
  };
}

export function openManifest(type = "pdf") {
  return (dispatch, getState) => {
    const { slotId } = stateSelector(getState());
    ProductScheduleSlotsRepository.showManifest(slotId, type);
  };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/calendar/ShowSlotModal/index.js